module.exports = __webpack_public_path__ + "img/divider.ec102387.svg";